module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "sidenav"
  }, [(_vm.isReady) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.active,
      "unique-opened": true,
      "default-openeds": _vm.opened,
      "collapse": _vm.bodyWidth < 1280
    }
  }, _vm._l((_vm.menus), function(menu) {
    return (_vm.permissionList === '' || _vm.checkMenuAuthority(menu)) ? _c('div', [(menu.children) ? _c('div', [_c('el-submenu', {
      attrs: {
        "index": ("" + (menu.id))
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: 'iconfont ' + menu.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "menu-name"
    }, [_vm._v(_vm._s(menu.name))])]), _vm._v(" "), _vm._l((menu.children), function(child) {
      return (_vm.permissionList === '' || _vm.checkMenuAuthority(child) || child.id === '600008') ? _c('div', {
        class: child.className ? child.className : null
      }, [_c('el-menu-item', {
        directives: [{
          name: "lx",
          rawName: "v-lx",
          value: (child.lx),
          expression: "child.lx"
        }],
        attrs: {
          "index": ("" + (child.id))
        },
        on: {
          "click": function($event) {
            _vm.jump(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))])], 1) : _vm._e()
    })], 2)], 1) : _c('div', [_c('router-link', {
      attrs: {
        "to": menu.path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": ("" + (menu.id))
      }
    }, [_c('i', {
      class: 'iconfont ' + menu.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "menu-name",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(menu.name))])])], 1)], 1)]) : _vm._e()
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c40b7738","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SideNav/SideNav.vue
// module id = 849
// module chunks = 11